import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL || "http://localhost:4010";

const socket = io(SOCKET_URL, {
  autoConnect: true,
  reconnection: true,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 10000,
  reconnectionAttempts: Infinity,
  transports: ["websocket", "polling"],
});

socket.on("connect", () => {
  console.log(`[Socket.IO] Connected successfully to ${SOCKET_URL} (ID: ${socket.id})`);
});

socket.on("disconnect", (reason) => {
  console.warn(`[Socket.IO] Disconnected:`, reason);
});

socket.on("reconnect", (attemptNumber) => {
  console.log(`[Socket.IO] Reconnected after ${attemptNumber} attempts`);
});

socket.on("connect_error", (error) => {
  console.warn(`[Socket.IO] Connection to ${SOCKET_URL} unavailable:`, error.message);
});

export default socket;